import { ArticleLabelType } from 'graphql-ts-types';

import type { ArticleLabel } from '../../types/labels';
import type { DiscountLabelsProps } from './index';

export type DisclaimerContent = {
  extraDisclaimerContent: string | null;
  legalDisclaimerContent: string | null;
} | null;

const findMatchingCampaign = (campaigns: DiscountLabelsProps['campaigns'], value: string) => {
  return (
    campaigns.find(
      ({ label, campaignBanner }) =>
        label === value &&
        (campaignBanner?.extraDisclaimerContent || campaignBanner?.legalDisclaimerContent)
    ) || null
  );
};

export const isClickable = (label: ArticleLabel['type'], isDisclaimerAvailable?: boolean) => {
  switch (label) {
    case ArticleLabelType.New:
      return true;
    case ArticleLabelType.Home24Selection:
      return true;
    case ArticleLabelType.Campaign:
      return isDisclaimerAvailable;
    default:
      return false;
  }
};

export const getDisclaimerContent = (
  campaigns: DiscountLabelsProps['campaigns'],
  value: string
): DisclaimerContent => {
  if (!campaigns?.length) return null;
  const campaign = findMatchingCampaign(campaigns, value);

  if (campaign?.campaignBanner) {
    const { legalDisclaimerContent = null, extraDisclaimerContent = null } =
      campaign.campaignBanner;

    return { extraDisclaimerContent, legalDisclaimerContent };
  }

  return null;
};

export const getColorByType = (type: ArticleLabel['type'], isBackgroundColor?: boolean) => {
  switch (type) {
    case ArticleLabelType.Campaign:
      return isBackgroundColor ? 'sys.marketing.grey' : 'colors.sys.marketing.grey';
    case ArticleLabelType.New:
      return isBackgroundColor ? 'sys.marketing.blue' : 'colors.sys.marketing.blue';
    case ArticleLabelType.ValuePack:
      return isBackgroundColor ? 'sys.marketing.purple' : 'colors.sys.marketing.purple';
    case ArticleLabelType.Home24Selection:
      return isBackgroundColor ? 'sys.marketing.home24.tipp' : 'colors.sys.marketing.home24.tipp';
    default:
      return isBackgroundColor ? 'sys.marketing.orange' : 'colors.sys.marketing.orange';
  }
};
